import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import Reaptcha from 'reaptcha';

const REACT_APP_RE_CAPTCHA_SITE_KEY = process.env.REACT_APP_RE_CAPTCHA_SITE_KEY;

import { reCaptchaSiteVerify } from '../../services/index';

const ReCAPTCHA = forwardRef(({ handleSuccess, handleError, handleExpire }, ref) => {
    const verify = async () => {
        try {
            const res = await captchaRef.current.getResponse();

            const verifyRes = await reCaptchaSiteVerify({ token: res });

            if (verifyRes.success === true) {
                handleSuccess();
            } else {
                handleError();
            }
        } catch (error) {
            console.log('reCaptchaSiteVerify: ', error);
        }
    };

    const reset = () => {
        captchaRef.current.reset();
    };

    const onLoad = () => {
        console.log('ReCAPTCHA onLoad');
    };
    const onExpire = () => {
        console.log('ReCAPTCHA onExpire');
        handleExpire?.();
    };
    const onError = () => {
        console.log('ReCAPTCHA onError');
    };
    const onRender = () => {
        console.log('ReCAPTCHA onRender');
    };

    const captchaRef = useRef(null);

    useImperativeHandle(
        ref,
        () => ({
            renderReCAPTCHA() {
                captchaRef.current.renderExplicitly();
            },
        }),
        []
    );

    return (
        <div>
            <Reaptcha
                sitekey={REACT_APP_RE_CAPTCHA_SITE_KEY}
                ref={captchaRef}
                onVerify={verify}
                onLoad={onLoad}
                onRender={onRender}
                // explicit
                onExpire={onExpire}
                onError={onError}
                hl="th"
            />
        </div>
    );
});

export default ReCAPTCHA;
